import './Draws.scss';
import Draw from '../draw/Draw';

const Draws = (props) => {

  return (
    <div className="Draws">
      {
        props.data.map((draw, i) => {
          return (
            <Draw
              key={i}
              data={draw}
            ></Draw>
          );
        })
      }
    </div>
  );
};

export default Draws;
